import type { DemoSet } from '../../types'
import { republicServicesInsight } from './insight'
import { networkPatterns } from './scripts/networkPatterns'
import { predictiveMaintenance } from './scripts/predictiveMaintenance'
import { unifiedView } from './scripts/unifiedView'

export const republicServicesSet: DemoSet = {
  id: 'republic-services',
  name: 'Republic Services',
  description:
    'Recycling operations investor demo. 47 MRFs + 2 Polymer Centers. Three use cases: Atlanta Today View → predictive maintenance with the data-source toggle → network-scale pattern recognition.',
  scripts: [unifiedView, predictiveMaintenance, networkPatterns],
  insight: republicServicesInsight,
  userPersona: {
    firstName: 'Mark',
    lastName: 'Bennett',
  },
}
